// Shared manufacturer lists per category - single source of truth
export const ULTRALIGHT_MANUFACTURERS = [
  'Acro Sport Inc','Adventurer','Aermacchi Lockheed','Aero AT','Aero Commander','Aero Designs',
  'Aeroalcool','Aerocomp Inc','Aerodrome','Aeromot','Aeronca','Aeroprakt Ltd','Aeropro',
  'Aeroprogress','Aerospatiale','Aerospool','Aerosport','Aerostar','Aerotechnik',
  'Air Command','Air Creation','Air Tractor','Aircoupe','Aircraft Technologies Inc','Airmax',
  'Akrotech','Alpi Aviation','Ambrosini','Amd','American Champion','American Legend',
  'Anderson, Greenwood & Co','ANG Patriot UA','Antonov','Apex','Apollo Fox','Applebay Aviation',
  'Aquila','Arnet Pereyra','Arv','Asap','Asso','Atec','Auster','Avama','Aviamilano',
  'Aviastroitel','Aviat','Aviatika','Aviation Norman Dube','Avid','Avions/Mudry',
  'Baken','Bakeng Duece','Barney Oldfield Aircraft Company','Beaver','Bede','Beechcraft',
  'Bell','Bellanca','Benton','Beriev','Bettsm','Blackshape','Boeing','Boeing/Stearman',
  'Boisavia','Bolkow','Boothby','Bowers','Bradley','Breezer','Breezy','Bristol',
  'British Aerospace','BRM Aero / Bristell','Brooklands Aerospace','Brush Master','Buccaneer',
  'Bucker Jungmann','Bucker Jungmeister','Buethe Enterprises','Burchinal',
  'Callair','Calvin Parker','Canadair','Canadian Car & Foundry','Canadian Home Rotors, Inc',
  'Canso','Capella','Caproni','Casbon','Cassutt','Celebrity','Cessna','CFM Aircraft','Cgs',
  'CH-7','Champion','Chance Vought','Chris Tena','Christavia','Christen','Cirrus','Cmelak',
  'Co-Z Development Corp','Col Air','Columbia','Comco Ikarus','Command-Aire','Commander',
  'Commonwealth','Commonwealth Aircraft Corp','Composite Jet','Consolidated',
  'Consolidated Vultee','Convair','Coot','Corben','Corby','Corsair','Corvus','Cubcrafters','Culver',
  'Curtiss','Curtiss-Wright','Czech Aircraft Works',
  'D Apuzzo','Damler','Davis Aircraft Corp','Dehavilland','Denemark Eric G','Diamond','Dimona',
  'Direct Fly','Douglas','Dova','Dream Aircraft','Dynaero',
  'Eaa Biplane','Eads/PZL','Eads/Socata','Eagle','Eagle R&D','Eaglerock','Earthstar','EDI',
  'Edmunds','Ekolot','Embraer','Ercoupe','Ercoupe/Alon','Ercoupe/Forney','Euro-ALA','Europa',
  'Evans','Evektor','Explorer Aviation','Express','EXTRA Aircraft',
  'Fairchild','Fairey','Falcon','Falconar','Fantasy Air','Farrar Davis','Ffa','Fiat','Fiesler',
  'Fisher','Fleet','Flight Design','Flightstar','Fluzeugbau','Fly Synthesis',
  'Flying K Enterprises','Focke Wulf','Fokker','Forster','Found Aircraft Co','Found Centennial',
  'Fournier','Frison','Fuji','Funk',
  'Garbadini','Gardan','Garner','General','General Avia','Gippsland Aeronautics','Glasair',
  'Globe','Gobosh','Gogetair','Golden Circle Air','Great Lakes','Great Plains','Grega','Grob',
  'Groen Bros','Groppo Aviazione','Grumman','Grumman/American General','Gryf Aircraft',
  'Gut Works','Gyroflug',
  'Habersetzer Gary L','Hamilton','Harmon','Harper-Behr Alyson','Hatz','Hatz/Kelly D','Hawk',
  'Hawker','HB-Flugtechnik','Helio','Hildreth','Hindustan Aeronautics Ltd','Hipps Superbirds',
  'Holmes Milton N','Howard',
  'I.C.P. Aviation','Iar S.a. Brasov','Icarus','Ilyushin','Indus Aviation Inc',
  'Iniziative Industriali','Interavia','Interplane','Interstate','Ipe Aeronaves','Ison',
  'Jabiru','Javelin','Jihlavan','JMB Aircraft','Jodel','Johnny Morris',
  'K & S','K-Meyer','Keleher','Ken Brock','Kingfisher','Kinner','Kit Fox','Klemm','Kolb',
  'Lake','Lancair','Langhurst','Laser','Legend','Legendary','Let','Lewinski Roman',
  'Leza Lockwood','Liberty Aerospace','Lockheed','Loehle','Lola-Utva','Lucas','Luscombe',
  'Macchi','Marawing','Marcel Jurca','Marquart','Martin (twa)','Maule','Max Holste','MB Avio',
  'MBB','Mcdonnel Douglas','Mcfee E Donald','Mdd','Merlin','Messerschmitt','Meyers','Micco',
  'Microleve','Midget','Midwest Aerosport','Mikoyan','Miles','Mince','Mitchell','Mitchell Wing',
  'Mitsubishi','Mong Sport','Monnett','Monocoupe','Mooney','Morane-Saulnier','Mosler Motors',
  'MSW Aviation','Mudry','Murphy','Mustang Aeronautics','MXP','Mystic',
  'Nanchang','Naval Aircraft','Navion','Navy','Nesmith','New Standard','Nieuport','Noorduyne',
  'Nord','North American','Nuwaco',
  'O.M.M.','Osprey Aircraft',
  'Papa 51 Ltd. Co.','Partenavia','Passenger','Pegasus Aviation','Phillips','Piaggio','Piel',
  'Pietenpol','Pilatus','Piper','Piper-Sterling','Pipistrel','Pitts','Polliwagen','Porterfield',
  'Preceptor','Prescott Aeronautical','Produits Aviatech Inc','Progressive',
  'Progressive Aerodyne','Promecc Aerospace','Protech','Prowler Aviation','Pulsar','Putzer','Pzl',
  'Quad City Ultralight','Questair','Quickie Aircraft Corp.','Quicksilver','Quikkit',
  'Rambo','Rand Robinson','Rans','Rearwin','Reflex Fiberglass Works','Refly','Reggiane','Reims',
  'Remos','Renegade','Repeat','Republic','Revolution','Rhein-Flugzeugbau','Rihn','Riley',
  'Robin','Rocket','Rockwell','Rokospol','Roland Aircraft','Rose','Rotary Air Force','Rotorway',
  'Ruschmeyer','Russell','Rutan','Rutten','Ryan',
  'S.G Aviation','Sa Ravin','Saab','Sabre Aircraft','Saint Louis','Scheibe','Schlepp',
  'Schweizer Glider','Scottish Aviation','Seawind','Senior Aero Sport','Sequoia','Shark Aero',
  'Siai Marchetti','Siat','Sibley Michael D','Silhouette','Skyfly','Slepcev Aircraft Company',
  'Slingsby','Slipstream','Smith','Smyth','Snow','Softex','Soko','Sokol','Sonaca','Sonex',
  'Sopwith','Sorrell Aircraft','Spartan','Speed','Spencer Aircraft','Spezio','Sport Copter',
  'Sportavia','Sports Aviation','Stampe','Star-Lite','Starduster','Staudcher','Steen','Stemme',
  'Stewart','Stinson','Stits','Stol','Stolp','Stout/Ford','Sukhoi','Supermarine','Swearingen',
  'Swift','Symphony Aircraft',
  'Tapanee','Tarragon','Taylor','Taylorcraft','Team Rocket','Team Tango','Technoavia','Tecnam',
  'Temco','Thorp','Tiffen Nord','Tiger Aircraft','Titan','TL-Ultralight','Tomark','Travel Air',
  'Tri-R Technologies','Trojan','Tupolev','Turbine Cubs','Turner',
  'Ultimate','Ultravia Aero','Urbanair','US Light Aircraft Corp',
  'V-Stol','Valentin','Van\'s Aircraft','Vancraft','Varga','Vector','Velocity Aircraft',
  'Vertical Aviation Technologies','Viking','Villeneuve','Vol Mediterrani','Volmer','Vultee',
  'VV-Avia',
  'W-F-W','Waco','Wag Aero','War Aircraft Replicas','Warner Aircraft','Wassmer',
  'Wd Flugzeugleichtbau Gmbh','Weatherly','Weedhopper','Wheeler','Wittman','Woodwind',
  'Woody Pusher','WSK-pzl-Mielec',
  'Xtremeair','Yakovlev','Zenair/Zenith','Zia','Zivko','Zlin','Zmaj','OTHERS'
];

// Propulsione Singola uses same as Ultraleggeri
export const SINGLE_ENGINE_MANUFACTURERS = ULTRALIGHT_MANUFACTURERS;

export const MULTI_ENGINE_MFR = [
  'Acro Sport Inc','Adam Aircraft','Adventurer','Aermacchi Lookheed','Aero','Aero Commander',
  'Aero Designs','Aerocomp Inc.','Aerodrome','Aeromot','Aeronca','Aeroprakt Ltd','Aeroprogress',
  'Aerospatiale','Aerosport','Aerostar','Air Command','Air Creation','Air Tractor',
  'Aircraft Technologies Inc','Airmax','Akrotech','Alpi Aviation','Ambrosini','American Champion',
  'American General','American Legend','Anderson, Greenwood & Co','ANG Patriot UA','Antonov',
  'Applebay Aviation','Arnet Pereyra','Arv','Asap','Atec','Auster','Aviastroitel','Aviat',
  'Aviatika','Aviation Norman Dube','Avid','Bakeng Duece','Barney Oldifeld Aircraft Company',
  'Beagle','Beaver','Bede','Beechcraft','Bell','Bellanca','Beriev','Bettsm','Boeing',
  'Boeing/Stearman','Bolkow','Boothby','Bowers','Bradley','Breezy','Bristol','British Aerospace',
  'Britten Norman','Brush Master','Buccaneer','Bucker Jungmann','Bucker Jungmeister',
  'Buethe Enterprises','Burchinal','Calvin Parker','Camair','Canadair','Canadian Car & Foundry',
  'Canadian Home Rotors, Inc.','Capella','Caproni','Casbon','Cassutt','Cessna','Cfm Aircraft',
  'Cgs','CH-7','Champion','Chance Vought','Chris Tena','Christavia','Christen','Cmelak',
  'Co-Z Development Corp','Commander','Commonwealth','Commonwealth Aircraft Corp','Composite Jet',
  'Consolidated','Consolidated Vultee','Convair','Coot','Corben','Corby','Corsair','Cubcrafters',
  'Culver','Curtiss','Curtiss-Wright','D Apuzzo','Damler','Davis Aircraft Corp','Dehavilland',
  'Denemark Eric G','Diamond','Dornier','Douglas','Dream Aircraft','Dynaero','Eaa Biplane',
  'Eagle R&D','Eaglerock','Earthstar','EDI','Edmunds','Embraer','Ercoupe','Europa','Evans',
  'Explorer Aviation','Express','Fairchild','Fairey','Falcon','Falconar','Farrar Davis','Fiat',
  'Fiesler','Fisher','Fleet','Flightstar','Flying K Enterprises','Focke Wulf','Fokker','Forster',
  'Found Aircraft Co','Fournier','Frison','Garbadini','Garner','General','Gippsland Aeronautics',
  'Glasair','Golden Circle Air','Great Plains','Grega','Groen Bros','Grumman','Gut Works',
  'Habersetzer Gary L','Hamilton','Harmon','Harper-Behr Alyson','Hatz','Hatz/Kelly D','Hawk',
  'Hawker','HB-Flugtechnik','Helio','Hildreth','Hipps Superbirds','Holmes Milton N','Howard',
  'Iar S.a. Brasov','Ilyushin','Iniziative Industriali','Interavia','Interstate','Ipe Aeronaves',
  'Ison','Jabiru','Javelin','Jodel','Johnny Morris','K & S','K-Meyer','Keleher','Ken Brock',
  'Kingfisher','Kinner','Kit Fox','Klemm','Lake','Lancair','Langhurst','Laser','Legend',
  'Legendary','Let','Lewinski Roman','Leza Lockwood','Lockheed','Loehle','Lola-Utva','Luscombe',
  'Macchi','Marcel Jurca','Maule','Max Holste','MBB','Mcdonnell Douglas','Mcfee e Donald',
  'Merlin','Messerschmitt','Midget','Midwest Aerosport','Mikoyan','Miles','Mince','Mitchell',
  'Mitchell Wing','Mitsubishi','Mong Sport','Monnett','Monocoupe','Morane-Saulnier',
  'Mosler Motors','Murphy','Mustang Aeronautics','Nanchang','Naval Aircraft','Navy','Nesmith',
  'New Standard','Nieuport','Noorduyne','Nord','North American','Nuwaco','Osprey Aircraft',
  'Papa 51 Ltd. Co.','Partenavia/Vulcanair','Passenger','Pegasus Aviation','Phillips','Piaggio',
  'Pietenpol','Pilatus','Piper','Piper-Sterling','Pitts','Polliwagen','Porterfield',
  'Prescott Aeronautical','Produits Aviatech Inc','Progressive','Progressive Aerodyne','Protech',
  'Prowler Aviation','Pulsar','Putzer','Pzl','Quad City Ultralight','Questair',
  'Quickie Aircraft Corp.','Quicksilver','Quikkit','Rand Robinson','Rans','Rearwin',
  'Reflex Fiberglass Works','Refly','Reggiane','Repeat','Republic','Revolution',
  'Rhein-Flugzeugbau','Rihn','Riley','Rockwell','Rose','Rotary Air Force','Russell','Rutan',
  'Rutten','Ryan','S.G Aviation','Sa Ravin','Sabre Aircraft','Saint Louis','Schlepp',
  'Schweizer Glider','Scottish Aviation','Seabird Amphibian','Seawind','Sequoia','Siai Marchetti',
  'Siblay Michael D','Silhouette','Skyfly','Slepcev Aircraft Company','Slipstream','Smith','Smyth',
  'Snow','Socata','Softex','Soko','Sokol','Sonex','Sopwith','Sorrell Aircraft','Spartan','Speed',
  'Spencer Aircraft','Spezio','Sport Copter','Sportavia','Sports Aviation','Stampe','Star-Lite',
  'Staudacher','Steen','Stewart','Stinson','Stits','Stol','Stolp','Stout/Ford','Sukhoi',
  'Supermarine','Swearingen','Swift','Tapanee','Taylor','Taylorcraft','Team Rocket','Team Tango',
  'Technoavia','Tecnam','Temco','Thorp','Titan','TL-Ultralight','Travel Air','Tri-R Technologies',
  'Trojan','Tupolev','Turbine Cubs','Turner','Ultimate','Ultravia Aero','US Light Aircraft Corp',
  'Van\'s Aircraft','Vancraft','Vector','Velocity Aircraft','Vertical Aviation Technologies','Viking',
  'Volmer','Vulcanair','Vultee','Waco','Wag Aero','War Aircraft Replicas','Warner Aircraft',
  'Wd Flugzeugleichtbau Gmbh','Weatherly','Weedhopper','Wheeler','Wing','Wittman','Woodwind',
  'Woody Pusher','Xtremeair','Yakovlev','Zenair/Zenith','Zia','Zivko','Zlin','Zmaj','OTHERS'
];

export const TURBOPROP_MFR = [
  'Acro Sport Inc','Aermacchi Lockheed','Aero','Aero Design','Aerocomp Inc.','Aerodrome',
  'Aeromot','Aeronca','Aeroprakt Ltd','Aeroprogress','Aerospatiale','Aerosport','Air Command',
  'Air Creation','Air Tractor','Aircraft Technologies Inc','Akrotech','Alpi Aviation','Ambrosini',
  'American Champion','American Legend','Anderson, Greenwood & Co','ANG Patriot UA','Antonov',
  'Applebay Aviation','Arnet Pereyra','Arv','Asap','Atec','Atr','Auster','Aviastroitel','Aviat',
  'Aviatika','Aviation Norman Dube','Avid','Ayres','Bac','Bae','Bakeng Duece',
  'Barney Oldfield Aircraft Company','Beaver','Bede','Beechcraft','Bell','Bellanca','Beriev',
  'Bettsm','Boeing','Boeing/Stearman','Bolkow','Boothby','Bowers','Bradley','Breezy','Bristol',
  'British Aerospace','Britten Norman','Brush Master','Buccaneer','Bucker Jungmann',
  'Bucker Jungmeister','Buethe Enterprises','Calvin Parker','Canadair',
  'Canadian Home Rotors, Inc.','Capella','Casa','Casa Saeta','Casbon','Cassutt','Cessna',
  'Cfm Aircraft','Cgs','CH-7','Champion','China Xian Aircraft Co','Chris Tena','Christavia',
  'Christen','Co-Z Develpment Corp','Commander','Commonwealth','Commonwealth Aircraft Corp',
  'Composite Jet','Consolidated','Consolidated Vultee','Convair','Coot','Corben','Corby',
  'Cubcrafters','Culver','Curtiss','Curtiss-Wright','D Apuzzo','Damler','Davis Aircraft Corp',
  'Dehavilland','Denemark Eric G','Dornier','Douglas','Dream Aircraft','Dynaero','Eaa Biplane',
  'Eads/PZL','Eads/Socata','Eagle R&D','Eaglerock','Earthstar','EDI','Edmunds','Embraer','Epic',
  'Ercoupe','Europa','Evans','Explorer Aviation','Express','Extra Aircraft','Fairchild','Fairey',
  'Falcon','Falconar','Farrar Davis','Fisher','Fleet','Flightstar','Flying K Enterprises',
  'Focke Wulf','Fokker','Folland','Forster','Fouga','Fournier','Frison','Gaf','Garner','General',
  'Glasair','Golder Circle Air','Great Plains','Grega','Groen Bros','Grumman','Gulfstream',
  'Gut Works','Hamilton','Harmon','Harper-Behr Alyson','Hatz','Hatz/Kelly D','Hawk','Hawker',
  'Hawker Siddeley','HB-Flugtechnik','Helio','Hildreth','Hipps Superbirds','Holmes Milton N',
  'Howard','Iar S.a. Brasov','Ikarus','Ilyushin','Iniziative Industriali','Interavia',
  'International','Interstate','Ipe Aeronaves','Ison','Jabiru','Javelin','Jet Provost','Jodel',
  'Johnny Morris','K & S','K-Meyer','Keleher','Ken Brock','Kingfisher','Kinner','Kit Fox','Klemm',
  'Lancair','Langhurst','Laser','Legend','Legendary','Let','Lewinski Roman','Leza Lockwood',
  'Lockheed','Loehle','Luscombe','Macchi','Marcel Jurca','Maule','Max Holste','MBB',
  'Mcdonnell Douglas','Mcfee E Donald','Merlin','Midget','Midwest Aerosport','Mikoyan','Miles',
  'Mince','Mitchell Wing','Mitsubishi','Mong Sport','Monnett','Monocoupe','Morane-Saulnier',
  'Mosler Motors','Murphy','Mustang Aeronautics','Nanchang','Navy','Nesmith','New Standard',
  'Nieuport','Nomad','Noorduyne','Nord','North American','Northrop','Nuwaco','Osprey Aircraft',
  'Pacific Aerospace','Papa 51 Ltd. Co.','Partenavia / Vulcanair','Pegasus Aviation','Phillips',
  'Piaggio','Pietenpol','Pilatus','Piper','Piper-Sterling','Pitts','Polliwagen','Porterfield',
  'Potez-Heinkel','Prescott Aeronautical','Produits Aviatech Inc','Progressive',
  'Progressive Aerodyne','Protech','Prowler Aviation','Pulsar','Pzl','Pzl-Mielec',
  'Quest Aircraft','Questair','Quickie Aircraft Corp.','Quicksilver','Quikkit','Rand Robinson',
  'Rans','Rearwin','Reflex Fiberglass Works','Refly','Repeat','Revolution','Rhein-Flugzeugbau',
  'Rihn','Riley','Rockwell','Rose','Rotary Air Force','Russell','Rutan','Rutten','Ryan',
  'S.G Aviation','Sa Ravin','Saab','Sabre Aircraft','Saint Louis','Seabird Amphibian','Seawind',
  'Sequoia','Shorts','Siai Marchetti','Sibley Micheal D','Sikorsky','Silhouette','Skyfly',
  'Slepcev Aircraft Company','Slipstream','Smith','Smyth','Soko','Sokol','Sonex','Sopwith',
  'Sorrell Aircraft','Spartan','Speed','Spencer Aircraft','Spezio','Sport Copeter','Sportavia',
  'Sports Aviation','Stampe','Star-Lite','Staudacher','Steen','Stewart','Stinson','Stits','Stolp',
  'Stout/Ford','Sukhoi','Swearingen','Swift','Tapanee','Taylor','Taylorcraft','Team Rocket',
  'Team Tango','Technoavia','Tecnam','Temco','Thorp','Titan','Travel Air','Tri-R Technologies',
  'Trojan','Tupolev','Turbine Cubs','Turner','Ultimate','Ultravia Aero','Vancraft','Vans',
  'Vector','Velocity Aircraft','Vertical Aviation Technologies','Viking','Vought','Vulcanair',
  'Waco','Wag Aero','War Aircraft Replicas','Warner Aircraft','Wd Flugzeugleichtbau Gmbh',
  'Weedhopper','Wheeler','Wittman','Woodwind','Woody Pusher','WSK-pzl-Mielec','Yakovlev',
  'Zenair/Zenith','Zia','Zivko','Zlin','OTHERS'
];

export const JET_MFR = [
  'Adam Aircraft','Aero','Aerocomp Inc.','Aerospatiale','Airbus','Antonov','Astra/Gulfstream',
  'Bac','Bae','Beechcraft','Beriev','Boeing','Bombardier','Bombardier/Challenger',
  'British Aerospace','Canadair','Cessna','Cirrus','Comac','Commander','Convair','Dassault',
  'Diamond','Eclipse','Embraer','Epic','Eviation','Excel-Jet','Fairchild Dornier','Fokker',
  'Gulfstream','Hawker','Hawker Beechcraft','Honda','IAI','Ilyushin','Learjet','Lockheed',
  'Maverick Jets','MBB','Mcdonnel Douglas','Mikoyan','Mitsubishi','Morane-Saulnier','Pilatus',
  'Piper','Rhein-Flughzeugbau','Rockwell','Sabre','Safire','SIno Swearingen','Sukhoi','Tupolev',
  'Viper Aircraft Corp','Westwind','Yakovlev','OTHERS'
];

export const HELI_MFR = [
  'Aerokopter','Aerospatiale','Agusta','Air & Space','Airbus','AK1-3','Bell',
  'Bell Agusta Aerospace','Beriev','Bolkow','Brantly','Canadian Home Rotors, Inc.','CH-7',
  'Continental Copters','Enstrom','Eurocopter','Fairchild Hiller','Fama','Guimbal','Hiller',
  'Hughes','Kaman','Konner','Mcculloch','Mcdonnell Douglas','Messerschmitt','Mil','Pzl',
  'Rhein-Flugzeugbau','Robinson','Rotorway','Schweizer','Scorpion','Sikorsky','Softex',
  'Texas Helicopter','Vertical Aviation','OTHERS'
];

export const CATEGORIES_MFR = {
  'ultraleggeri': ULTRALIGHT_MANUFACTURERS,
  'propulsione-singola': ULTRALIGHT_MANUFACTURERS,
  'propulsione-multipla': MULTI_ENGINE_MFR,
  'turboelica': TURBOPROP_MFR,
  'jet': JET_MFR,
  'elicotteri': HELI_MFR,
};
